import { ServicesManager } from '@ohif/core';
import { getDefaultStore } from 'jotai';
import {
  activeDetectionAtom,
  incrementActiveDetectionIndexAtom,
  setDetectionStatusAtom,
  toogleDisplayPredictionsAtom,
} from './contexts/predictions.atoms';
import { CLEANING_PANEL_NAME } from './getPanelModule';
import { id } from './id';
import { DetectionCleaningStatus } from './types/prediction.type';

export function getCommandsModule({
  servicesManager,
}: {
  servicesManager: ServicesManager;
}) {
  function setCurrentDetectionStatus(status: DetectionCleaningStatus) {
    const store = getDefaultStore();

    const { panelService } = servicesManager.services;

    panelService.activatePanel(
      `${id}.panelModule.${CLEANING_PANEL_NAME}`,
      true
    );

    store.set(setDetectionStatusAtom, {
      status,
      detectionId: store.get(activeDetectionAtom),
    });
    store.set(incrementActiveDetectionIndexAtom);
  }

  const actions = {
    togglePredictionsDisplay: () => {
      const defaultStore = getDefaultStore();
      defaultStore.set(toogleDisplayPredictionsAtom);
    },
    setCurrentDetectionPositive: () => {
      setCurrentDetectionStatus('POSITIVE');
    },
    setCurrentDetectionNegative: () => {
      setCurrentDetectionStatus('NEGATIVE');
    },
    setCurrentDetectionUncertain: () => {
      setCurrentDetectionStatus('UNCERTAIN');
    },
  };

  const definitions = {};
  Object.keys(actions).forEach((actionName) => {
    definitions[actionName] = {
      commandFn: actions[actionName],
      storeContexts: [],
      options: {},
    };
  });

  return {
    actions,
    definitions,
    defaultContext: 'CORNERSTONE',
  };
}
